import React from "react";
import _ from "lodash";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./DocumentationForm.type";
import { withRouter } from "react-router-dom";
import {
  RootState,
  AppNotifications,
} from "../../../../models";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { NotificationActions } from "../../../../store/actions";
import DocumentationFormPresenter from "./DocumentationForm.presenter";
import { DocumentStatus, DocumentInputModel } from "../../../../models"
import { DocumentService } from "../../../../services";
import { loadCallback } from "../../../../utils";

class DocumentationFormContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    this.state = {
      publish: true,
      fileUpload: undefined,
      fileType: "",
      isDupplicate: false
    }
  }

  handleStatusChange = () => {
    this.setState({
      publish: !this.state.publish
    })
  }

  handleFileUpload = (event) => {
    const file: File = event.target.files[0];
    
    if (file) {
      this.setState({
        fileUpload: file,
        fileType: file.type
      }, () => {
        this.props.documentList.forEach((item) => {
          if (item.name === this.state.fileUpload.name) {
            this.setState({
              isDupplicate: true
            })
          }
        })
      })
    }
  }

  removeFileUpload = () => {
    this.setState({
      fileUpload: undefined
    })
  }

  handleSubmit = (val: any) => {
    let data: any = {
      status: this.state.publish ? DocumentStatus.PUBLISH : DocumentStatus.UNPUBLISH,
      flag: this.props.flag,
    };
    data = _.pickBy(data, (v) => !_.isUndefined(v));

    this.onUploadFile(data);
  };

  onUploadFile = (data: DocumentInputModel) => {
    const formData = new FormData();
    formData.append("status", data.status);
    formData.append("file", this.state.fileUpload);
    formData.append("flag", data.flag);
    DocumentService.uploadFile(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.SUCCESS, message: "Upload file success" });
          loadCallback(this.props.onComplete_Create);
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload file failed" });
        }
      })
      .catch((err) => {
        console.log(err)
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Upload file failed" });
      });
  };

  render() {
    return (
      <DocumentationFormPresenter
        {...this.props}
        {...this.state}
        handleStatusChange={this.handleStatusChange}
        handleFileUpload={this.handleFileUpload}
        removeFileUpload={this.removeFileUpload}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(DocumentationFormContainer)
);